'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var styleInject = require('../styleInject.js');

var css_248z = ".Option-module_inputWrapper__fG7fm{height:0;overflow:hidden;width:0}.Option-module_inputWrapper__fG7fm:focus{outline:none}";
var styles = {"inputWrapper":"Option-module_inputWrapper__fG7fm"};
styleInject["default"](css_248z, '14358efb-596a-4f09-bbbc-56ce9473c748');

exports["default"] = styles;
